/* CBH Product Card JavaScript Functionality */

class CBHProductCard {
  constructor() {
    this.init();
  }

  init() {
    // Bind events
    this.bindEvents();
    
    // Initialize color swatches
    this.initColorSwatches();
  }

  bindEvents() {
    // Color swatch clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cbh-color-swatch')) {
        this.handleColorSwatchClick(e.target.closest('.cbh-color-swatch'));
      }
      
      // Size option clicks
      if (e.target.closest('.cbh-size-option')) {
        this.handleSizeClick(e.target.closest('.cbh-size-option'));
      }
      
      // Single variant add to cart
      if (e.target.closest('.cbh-add-to-cart-btn')) {
        this.handleAddToCart(e.target.closest('.cbh-add-to-cart-btn'));
      }
      
      // Mobile plus button clicks
      if (e.target.closest('.cbh-mobile-plus-btn')) {
        this.handleMobilePlusClick(e.target.closest('.cbh-mobile-plus-btn'));
      }
      
      // Mobile drawer close button
      if (e.target.closest('.cbh-mobile-drawer-close')) {
        this.closeMobileDrawer();
      }
      
      // Mobile drawer overlay click
      if (e.target.closest('.cbh-mobile-drawer-overlay')) {
        this.closeMobileDrawer();
      }
    });

    // Product image hover events (desktop only)
    document.addEventListener('mouseenter', (e) => {
      if (e.target.closest('.product-item')) {
        this.handleImageHover(e.target.closest('.product-item'), 'enter');
      }
    }, true);

    document.addEventListener('mouseleave', (e) => {
      if (e.target.closest('.product-item')) {
        this.handleImageHover(e.target.closest('.product-item'), 'leave');
      }
    }, true);
  }

  initColorSwatches() {
    // Set first color as active by default
    document.querySelectorAll('.cbh-color-options').forEach(container => {
      const firstSwatch = container.querySelector('.cbh-color-swatch');
      if (firstSwatch && !firstSwatch.classList.contains('cbh-color-swatch--active')) {
        firstSwatch.classList.add('cbh-color-swatch--active');
      }
    });
  }

  handleColorSwatchClick(swatch) {
    const container = swatch.closest('.cbh-color-options');
    const productId = container.dataset.productId;
    
    // Remove active class from all swatches in this product
    container.querySelectorAll('.cbh-color-swatch').forEach(s => {
      s.classList.remove('cbh-color-swatch--active');
    });
    
    // Add active class to clicked swatch
    swatch.classList.add('cbh-color-swatch--active');
    
    // Update product image if needed (optional)
    this.updateProductImage(productId, swatch.dataset.variantId);
  }

  handleSizeClick(sizeButton) {
    if (sizeButton.disabled) return;
    
    const variantId = sizeButton.dataset.variantId;
    const productHandle = sizeButton.dataset.productHandle;
    
    this.addToCart(variantId, sizeButton);
  }

  handleAddToCart(button) {
    const variantId = button.dataset.variantId;
    const productHandle = button.dataset.productHandle;
    
    this.addToCart(variantId, button);
  }

  async addToCart(variantId, button) {
    if (!variantId) return;
    
    // Add loading state
    button.classList.add('cbh-loading');
    button.disabled = true;
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });
      
      if (response.ok) {
        // Success state
        button.classList.remove('cbh-loading');
        button.classList.add('cbh-success');
        
        // Update cart count and open cart drawer
        this.updateCartCount();
        this.openCartDrawer();
        
        // Reset button after 2 seconds
        setTimeout(() => {
          button.classList.remove('cbh-success');
          button.disabled = false;
        }, 2000);
        
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      button.classList.remove('cbh-loading');
      button.disabled = false;
      
      // Show error message
      this.showError(button, 'Failed to add to cart');
    }
  }

  updateCartCount() {
    // Update cart count in header if cart drawer exists
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  openCartDrawer() {
    // Try multiple methods to open Corner COWI cart drawer
    
    // Method 1: Click the cart launcher button
    const cartLauncher = document.querySelector('#corner-cowi-cart-sidetab-launcher');
    if (cartLauncher) {
      cartLauncher.click();
      return;
    }
    
    // Method 2: Try to trigger Corner COWI's global function
    if (typeof window.cornerCOWI !== 'undefined' && typeof window.cornerCOWI.openCart === 'function') {
      window.cornerCOWI.openCart();
      return;
    }
    
    // Method 3: Dispatch custom event that Corner COWI might listen for
    document.dispatchEvent(new CustomEvent('corner-cowi:open-cart', {
      bubbles: true,
      detail: { source: 'cbh-product-card' }
    }));
    
    // Method 4: Try to find and click any cart-related button
    const cartButtons = document.querySelectorAll('[id*="cart"], [class*="cart"], [data-cart]');
    cartButtons.forEach(button => {
      if (button.textContent.toLowerCase().includes('cart') || 
          button.getAttribute('aria-label')?.toLowerCase().includes('cart')) {
        button.click();
        return;
      }
    });
    
    // Method 5: Fallback - try theme's cart drawer if available
    if (window.cart && typeof window.cart.openCartDropdown === 'function') {
      window.cart.openCartDropdown();
    }
  }

  showError(button, message) {
    const originalText = button.textContent;
    button.textContent = message;
    button.style.background = '#dc3545';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.style.background = '';
    }, 3000);
  }

  handleImageHover(imageContainer, action) {
    const productItem = imageContainer.closest('.product-item');
    if (!productItem) return;

    const productInfo = productItem.querySelector('.cbh-product-info');
    if (!productInfo) return;

    // Check if product is sold out - don't show hover effects for sold out products
    const soldOutElement = productInfo.querySelector('.sold-out');
    if (soldOutElement) return; // Don't show hover effects for sold out products

    const defaultInfo = productInfo.querySelector('.cbh-default-info');
    const hoverInfo = productInfo.querySelector('.cbh-hover-info');

    if (!defaultInfo || !hoverInfo) return;

    if (action === 'enter') {
      // Hide default info and show hover info
      defaultInfo.style.opacity = '0';
      hoverInfo.style.opacity = '1';
      hoverInfo.style.display = 'block';
    } else if (action === 'leave') {
      // Show default info and hide hover info
      defaultInfo.style.opacity = '1';
      hoverInfo.style.opacity = '0';
      hoverInfo.style.display = 'none';
    }
  }

  updateProductImage(productId, variantId) {
    // Optional: Update product image when color changes
    // This would require additional API calls to get variant images
    console.log('Color changed for product:', productId, 'variant:', variantId);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CBHProductCard();
  });
} else {
  new CBHProductCard();
}

// Export for potential external use
window.CBHProductCard = CBHProductCard;
